var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlankIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m993.74 581.26c62.156 0 112.5-50.391 112.5-112.5 0-62.156-50.344-112.5-112.5-112.5s-112.5 50.344-112.5 112.5c0 62.109 50.344 112.5 112.5 112.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.28 785.16 324.37-96.422 259.6-11.297v-58.688c0-10.359 8.3906-18.75 18.75-18.75s18.75 8.3906 18.75 18.75v112.5c0 31.078 25.172 56.25 56.25 56.25h168.74c31.078 0 56.25-25.172 56.25-56.25s-25.172-56.25-56.25-56.25h-112.5v-99.75c0-62.672-60.375-107.72-120.47-89.859l-645.56 191.95c-29.766 8.8594-46.734 40.172-37.875 69.938s40.172 46.734 69.938 37.875z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlankIcon);
export default __webpack_public_path__ + "static/media/plank-icon.f13e93fc79b6c6ce50edf396bdb9ce0d.svg";
export { ForwardRef as ReactComponent };